import * as React from "react";
import {Link} from "react-router-dom";
import * as classNames from 'classnames';
import {ChildrenType} from "../../_definitions/styleteq";

export interface Props {
    to: string;
    onClick?: any;
    active: boolean;
    children?: ChildrenType;
}

const LinkComponent = (props: Props) => {
    const {to, onClick, active, children} = props;

    return (
        <li className={classNames({active: active})}>
            {!onClick &&
            <Link to={to}>{children}</Link>
            }
            {onClick &&
            <a onClick={onClick}>{children}</a>
            }
        </li>
    );
};
export default LinkComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/sidebarLink/LinkComponent.tsx